import api from '@api/Api';

export default {

    downloadExport(id) {
        return api().post(`/exports/${id}/download`);
    },

    deleteExport(id) {
        return api().delete(`/exports/${id}`);
    },

}
